export default __webpack_public_path__ + "static/media/dotnet_color.00fa436d.png";